import {
  bookmarkProfile,
  getCustomerFields,
  addCacheCandidates,
  deleteCacheCandidates,
} from "../../utils/apiFunctions";
import { helpers, required, maxLength } from "vuelidate/lib/validators";

import toast from "./toast";

const NOTICE_PERIODS = {
  "15 days": "15 days",
  "30 days": "1 Month",
  "60 days": "2 Months",
  "90 days": "3 Months",
  Immediate: "Immediate",
  "currently on notice period": "Currently in Notice Period",
};

const SEARCH_TYPES = {
  1: "Resume Title",
  2: "Resume Title and Keyskills",
  3: "Resume Synopsis",
  4: "Entire Resume",
};

const GENDERS = {
  male: "Male",
  female: "Female",
  others: "Others",
};

const WORK_TYPE = {
  hybrid: "Hybrid",
  remote: "Remote",
  fromOffice: "From Office",
};

const EMPLOYMENT_TYPE = {
  "full time": "Full Time",
  "part time": "Part Time",
  "self employed": "Self Employed",
  freelance: "Freelance",
  trainee: "Trainee",
  internship: "Internship",
};

const EDUCATION = {
  All: "All",
  doctorate: "Doctorate/PhD",
  masters: "Masters/Post-Graduation",
  graduation: "Graduation/Diploma",
  "12th": "12th",
  "10th": "10th",
};

const ACTIVE_IN = {
  All: "All",
  7: "7 Days",
  15: "15 Days",
  30: "30 Days",
  60: "60 Days",
  90: "90 Days",
};

const VIEW_PROFILE = {
  1: "All",
  2: "Already Viewed",
  3: "Hide Viewed Profiles",
  4: "Bookmarked Profiles",
  5: "Hide Bookmarked Profiles",
};

export default {
  mixins: [toast],
  data() {
    return {
      customFieldsArray: [],
      populatedCustomFields: { candidates: [] },
      customFieldsTemplate: {
        customFields: {},
      },
    };
  },
  validations: {
    saveSearchTitle: {
      required,
      maxLength: maxLength(128),
    },
    search: {
      experienceTo: {
        greater: (value, vm) => {
          return (
            !helpers.req(value) ||
            !helpers.req(vm.experienceFrom) ||
            parseFloat(value) > parseFloat(vm.experienceFrom)
          );
        },
      },
      salaryTo: {
        greater: (value, vm) => {
          return (
            !helpers.req(value) ||
            !helpers.req(vm.salaryFrom) ||
            parseFloat(value) > parseFloat(vm.salaryFrom)
          );
        },
      },
      ageTo: {
        greater: (value, vm) => {
          return (
            !helpers.req(value) ||
            !helpers.req(vm.ageFrom) ||
            parseFloat(value) > parseFloat(vm.ageFrom)
          );
        },
      },
    },
  },
  methods: {
    async showJobModal() {
      await this.setSendToThirdParty();
      if (this.whereFrom === "talentpool") {
        this.showAddToJd = true;
      } else {
        this.selectedjd = this.getJobIDs;
        this.showCandTPModal = true;
      }
    },
    // Add to methods
    async goToAddToTalentPool() {
      try {
        await this.setSendToThirdParty();
        const res = await addCacheCandidates(this.populatedCustomFields);
        if (res.status == 200) {
          this.$router.push({
            name: "AddFromThirdParty",
            query: {
              fromPage: "search",
            },
          });
        }
      } catch (error) {
        console.error("err:", error);
      }
    },

    async setSendToThirdParty() {
      this.setSelectedProfiles();
      await deleteCacheCandidates({ emails: [] });
      await this.getCustomFields();
      this.populatedCustomFieldsArr();
    },

    async getCustomFields() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
        this.customFieldsArray.forEach((field) => {
          if (field.controlType === "upload_file") {
            this.customFieldsTemplate[field.key] = null;
          } else if (field.fieldType == "default") {
            field.controlType == "multi_select" ||
            field.controlType === "multi_text"
              ? (this.customFieldsTemplate[field.key] = [])
              : (this.customFieldsTemplate[field.key] = "");
          } else {
            field.controlType == "multi_select" ||
            field.controlType === "multi_text"
              ? (this.customFieldsTemplate["customFields"][field.key] = [])
              : (this.customFieldsTemplate["customFields"][field.key] = "");
          }
        });
      } catch (error) {
        console.error(error);
      }
    },

    setSelectedProfiles() {
      const selectedUserIDs = new Set(this.selectCand);
      if (this.profiles) {
        this.selectedProfiles = this.profiles.filter((profile) => {
          if (selectedUserIDs.has(profile.userID)) {
            if (
              !this.selectedProfiles.some(
                (selected) => selected.userID === profile.userID
              )
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    closeAddToJDSuccessMultiple() {
      this.selectedProfiles = [];
      this.selectCand = [];
    },

    populatedCustomFieldsArr() {
      let fieldMapping = {
        image: "imageMedia",
        city: "currentLocation",
        willingToRelocate: "willingToRelocate",
        currentCTC: "currentCTC",
        gender: "gender",
        willingToRelocateTo: "willingToRelocateTo",
        idProof: "idProof",
        displayEmail: "altEmail",
        altPhoneNumber: "altPhoneNumber",
        noticePeriod: "noticePeriod",
        otherNoticePeriod: "otherNoticePeriod",
        highestQualification: "highestQualification",
        experienceLetter: "experienceLetter",
        expectedCTC: "expectedCTC",
        resumePath: "resume",
        name: "name",
        email: "email",
        phoneNumber: "phoneNumber",
        source: "source",
        Othersource: "otherSource",
        totalYearsOfExp: "experince",
        // skillsArray: "skills",
      };

      this.populatedCustomFields.candidates = [];

      this.selectedProfiles.forEach((profile) => {
        let customFieldsObject = JSON.parse(
          JSON.stringify(this.customFieldsTemplate)
        );

        for (let profileField in profile) {
          if (Object.prototype.hasOwnProperty.call(profile, profileField)) {
            if (fieldMapping[profileField]) {
              let customField = fieldMapping[profileField];
              if (
                Object.prototype.hasOwnProperty.call(
                  customFieldsObject.customFields,
                  customField
                )
              ) {
                customFieldsObject.customFields[customField] =
                  profile[profileField];
              } else if (
                Object.prototype.hasOwnProperty.call(
                  customFieldsObject,
                  customField
                )
              ) {
                customFieldsObject[customField] = profile[profileField];
              }
            }
          }
          let fullName =
            (profile.firstName ? profile.firstName : "") +
            (profile.middleName ? " " + profile.middleName : "") +
            (profile.lastName ? " " + profile.lastName : "");

          // Add fullName to customFieldsObject.customFields
          customFieldsObject.name = fullName.trim();
          if (profileField == "skills") {
            const skillNames = profile.skills.map((item) => item.skillName);
            customFieldsObject.skills = skillNames;
          }
        }
        this.populatedCustomFields.candidates.push(customFieldsObject);
      });
    },

    toggleNoticePeriod(key) {
      this.search.noticePeriod = this.search.noticePeriod === key ? null : key;
    },
    preventKeys(evt, keys) {
      const value = evt.target.value;

      if (keys.includes(evt.key)) {
        evt.preventDefault();
        return;
      }

      const regex = /^\d{0,3}(\.\d{0,3})?$/;

      const newValue = value + evt.key;
      if (!regex.test(newValue)) {
        evt.preventDefault();
      }
    },
    floatOnly(evt, model) {
      evt.preventDefault();
      if (model) {
        model = model.split(".");
        let variable = this;
        while (model.length > 1) {
          variable = variable[model.shift()];
        }
        variable[model.shift()] = (evt.target.value + evt.key)
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*?)\..*/g, "$1");
      } else {
        evt.target.value = (evt.target.value + evt.key)
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*?)\..*/g, "$1");
      }
    },
    async bookmark(profile) {
      profile.bookmark = !profile.bookmark;
      const res = await bookmarkProfile({ email: profile.email });
      if (res.status == 200) {
        if (!profile.bookmark) {
          this.successModal("Bookmark Removed Successfully");
        } else {
          this.successModal("Bookmarked Successfully");
        }
      } else {
        profile.bookmark = !profile.bookmark;
        this.errorModal("Failed to bookmark profile");
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.successModal("Copied to clipboard");
    },
    toggleContactDropdown(userID) {
      this.isCopied = "";
      if (this.currentContactDropdown && this.currentContactDropdown === userID)
        this.currentContactDropdown = null;
      else this.currentContactDropdown = userID;
    },
    hideCopyToClipboardOnFocusOut() {
      this.currentContactDropdown = null;
    },
    goToPages() {
      this.currentPage = Math.min(Math.max(1, this.goToPage), this.totalPages);
      this.goToPage = null;
    },
    formatSkills(skills) {
      let skillNames = [];
      skills.forEach((skill) => {
        skillNames.push(skill.skillName);
      });
      return skillNames.join(", ") || "NA";
    },
    formatEducation(education) {
      if (!education) return "NA";

      let educationData = [education.degree, education.institute].filter(
        (value) => value
      );
      return educationData.join(", ");
    },
    formatExperience(experience) {
      if (!experience && experience !== 0) return "NA";
      else if (experience === 1) return `${experience} year`;
      else return `${experience} years`;
    },
    resetSearch(clearOtherFields = true) {
      let prevSearch = {};
      if (!clearOtherFields) prevSearch = { ...this.search };

      this.search = {
        ...prevSearch,
        mandatoryKeywords: [],
        keywords: [],
        skills: [],
        location: [],
        preferredLocation: [],
        gender: [],
        workType: [],
        employmentType: [],
        itSkills: [{ skillName: "", yearsOfExp: "", mandatory: false }],
        industry: [],
        designation: [],
        minimumEducation: null,
        experienceTo: null,
        experienceFrom: null,
        salaryFrom: null,
        salaryTo: null,
        ageFrom: null,
        ageTo: null,
        noticePeriod: null,
        activeInDays: null,
        viewProfile: null,
        willingToRelocate: false,
        searchType: "4",
      };
    },
    addMandatoryKeyword(keyword) {
      this.search.mandatoryKeywords.push(keyword);
    },
    removeMandatoryKeyword(keyword) {
      this.search.mandatoryKeywords = this.search.mandatoryKeywords.filter(
        (key) => key !== keyword
      );
    },
    removeKeyword(index) {
      this.search.mandatoryKeywords = this.search.mandatoryKeywords.filter(
        (key) => key !== this.search.keywords[index]
      );
      this.search.keywords.splice(index, 1);
    },
    toDropdownOptions(options) {
      const dropdownOptions = Object.keys(options).map((key) => ({
        value: key,
        text: options[key],
      }));

      // Ensure "All" is at the beginning of the array
      dropdownOptions.sort((a, b) =>
        a.value === "All" ? -1 : b.value === "All" ? 1 : 0
      );

      return dropdownOptions;
    },
    validateEmploymentType(employmentType) {
      return EMPLOYMENT_TYPE.filter(
        (type) =>
          type.toLowerCase() === employmentType.toLowerCase() &&
          !this.search.employmentType.includes(type.toLowerCase())
      ).length;
    },
    validateWorkType(workType) {
      return WORK_TYPE.filter(
        (type) =>
          type.toLowerCase() === workType.toLowerCase() &&
          !this.search.workType.includes(type.toLowerCase())
      ).length;
    },
    validateGender(gender) {
      return (
        GENDERS.includes(gender.toLowerCase()) &&
        !this.search.gender.includes(gender.toLowerCase())
      );
    },
    addKeyword(e) {
      if (e.key === "Enter") {
        if (this.currentKeyword) {
          if (
            !this.search.keywords.some(
              (keyword) =>
                keyword.toLowerCase() === this.currentKeyword.toLowerCase()
            )
          )
            this.search.keywords.push(this.currentKeyword);
          this.currentKeyword = "";
        }
      } else if (e.key === "Backspace" && !this.currentKeyword) {
        this.search.keywords.pop(); // Remove last keyword
      }
    },
  },
  computed: {
    //constants
    SEARCH_TYPES() {
      return SEARCH_TYPES;
    },
    VIEW_PROFILE() {
      return VIEW_PROFILE;
    },
    ACTIVE_IN() {
      return ACTIVE_IN;
    },
    EDUCATION() {
      return EDUCATION;
    },
    EMPLOYMENT_TYPE() {
      return EMPLOYMENT_TYPE;
    },
    WORK_TYPE() {
      return WORK_TYPE;
    },
    NOTICE_PERIODS() {
      return NOTICE_PERIODS;
    },
    GENDERS() {
      return GENDERS;
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
  },
};
